import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const 
LandingPageHeroTwo = () => {
  return (
    <>
      <div className="video-wrapper">
        <video
          style={{height:"88vh"}}
          id="video"
          loop=""
          autoplay=""
          playsinline=""
          muted
          width="100%"
          height="100%"
          poster="https://img1.wsimg.com/isteam/videos/naBxa52">
          <source src="/static/videos/hero" type="video/mp4" />
          <source src="/static/videos/hero" type="video/ogg" />
        </video>
        {/* <video
          src="https://websites.godaddy.com/categories/v4/videos/raw/video/naBxa52"
          type="video/mp4"
          poster="https://img1.wsimg.com/isteam/videos/naBxa52"
          loop=""
          autoplay=""
          playsinline=""
          className="video"
          __idm_id__="260149249"></video> */}
        <div className="overlay ">
          <section
            style={{height:"88vh",background:"linear-gradient(to bottom, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%)"}}
            loading="lazy"
            id="heroTwo"
            className=" mx-auto flex flex-col justify-center items-center ">
            <div className="container mx-auto xl:px-5 text-center md:text-left pb-3 flex justify-center items-center" data-aos="fade-up">
              <div className=" xl:px-5  xl:mx-5 flex justify-center items-center flex-col">
                <h1 className="border-b fs-fjalla pb-2 uppercase  text-center">SIMPLIFIED Renting for  awesome  PEOPLE</h1>
                <Link href="/find-a-soulroom">
                  <a
                    className="btn-get-started scrollto rounded-0  fs-16-18   text-normal "
                    style={{ fontFamily: 'Josefin Sans' }}>
                    Find Properties
                  </a>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* <section loading="lazy" id="hero" className="  d-flex flex-column justify-content-center align-items-center ">
        <div className="lg:container px-xl-5 text-center text-md-left pb-3" data-aos="fade-up">
          <div className="px-xl-5 mx-xl-5">
            <h1 className="border-bottom fs-fjalla pb-2">SIMPLIFIED SHARED LIVING FOR AWESOME PEOPLE</h1>
            <Link href="/find-a-soulroom">
              <a
                className="btn-get-started scrollto rounded-0  fs-16-18   text-normal "
                style={{ fontFamily: 'Josefin Sans' }}>
                Find Properties
              </a>
            </Link>
          </div>
        </div>
      </section> */}
      {/* <!-- End Hero --> */}
      <Styles/>
    </>
  );
};

export default LandingPageHeroTwo;
// style={{backgroundImage: "url('/images/hero.png')"}}
